export class AlertMessage {
  code: string;
  title: string;
  message: string;

  constructor(code: string, title: string, message: string) {
    this.code = code;
    this.title = title;
    this.message = message;
  }
}
